// src/components/Navbar.tsx
import { useLocation, A } from "@solidjs/router";
import { sideMenuRoutes } from "../routes";
import MobileNavbar from "./mobileNavbar";
import usePermissions from "../lib/usePermissions";

const Navbar = () => {
  const location = useLocation();
  const permissions = usePermissions();

  return (
    <>
      <MobileNavbar />
      <div class="border-t border-gray-300 dark:border-gray-700">
        <div class="hidden md:flex gap-4 px-8">
          {sideMenuRoutes.map((menu) => {
            if (
              typeof menu?.permission === "undefined" ||
              permissions()?.has(menu?.permission)
            ) {
              let isActive = location.pathname === menu.pathname;
              if (menu?.pathname !== "/")
                isActive = location.pathname.indexOf(`${menu.pathname}`) > -1;

              return (
                <nav>
                  <A
                    href={menu.pathname}
                    class={
                      isActive
                        ? "flex items-center text-[var(--color-primary)] border-b-2 border-[var(--color-primary)] p-2 first:px-0 font-semibold"
                        : "flex items-center p-2 first:px-0 dark:text-white"
                    }
                  >
                    <div>{menu.name}</div>
                  </A>
                </nav>
              );
            }
            return <></>;
          })}
        </div>
      </div>
    </>
  );
};

export default Navbar;
